import { Injectable } from '@angular/core';
import { BaseSite, Converter, Occ } from '@spartacus/core';

@Injectable({ providedIn: 'root' })
export class CustomBaseSiteNormalizer implements Converter<Occ.BaseSite, BaseSite> {
  convert(source: Occ.BaseSite, target?: BaseSite): BaseSite {
    if (target === undefined) {
      target = { ...(source as any) } as BaseSite;
    }

    // We take the first store as the base store.
    target.baseStore = source.stores?.[0];

    return target;
  }
}
